import http from "../config/axiosConfig/http-common";
import { GetConfiguracoes, GetPermissoes, SetConfiguracoes, SetPermissoes } from "../config/localstorageConfig/localstorage";
import ServiceBase from "./service.base";

class UsuarioService extends ServiceBase {

    getPermissoes() {
        return http.get("/Usuarios/Permissoes");
    }

    getConfiguracoes() {
        return http.get("/Usuarios/Configuracoes");
    }

    async setCachePermissoes() {
        const permissoes = GetPermissoes();
        if (permissoes) {
            return;
        }

        try {
            const response = await this.getPermissoes();
            SetPermissoes(response.data.value);
        } catch (e) {
            SetPermissoes({});
            console.error("Erro ao carregar permissoes:", e);
            throw e;
        }
    }

    async setCacheConfiguracoes() {
        const configuracoes = GetConfiguracoes();
        if (configuracoes) {
            return;
        }

        try {
            const response = await this.getConfiguracoes();
            SetConfiguracoes(response.data);
        } catch (e) {
            SetConfiguracoes({});
            console.error("Erro ao carregar configuracoes:", e);
            throw e;
        }
    }
}

export default new UsuarioService();